var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderMedicines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18356",
    transform: "translate(-839 -462)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 171",
    width: 65,
    height: 65,
    rx: 32.5,
    transform: "translate(839 462)",
    style: {
      fill: "#ea5d6e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 493"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": 898598
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 422",
    d: "M135.559 246H130.7a.7.7 0 1 0 0 1.408h4.859a.7.7 0 1 0 0-1.408z",
    transform: "translate(732.631 247.796)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 423",
    d: "M56.891 246h-2.069a.7.7 0 1 0 0 1.408h2.069a.7.7 0 1 0 0-1.408z",
    transform: "translate(803.166 247.796)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 424",
    d: "M135.559 312H130.7a.7.7 0 0 0 0 1.408h4.859a.7.7 0 0 0 0-1.408z",
    transform: "translate(732.631 186.444)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 425",
    d: "M56.891 312h-2.069a.7.7 0 0 0 0 1.408h2.069a.7.7 0 0 0 0-1.408z",
    transform: "translate(803.166 186.444)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 426",
    d: "M135.559 379.408a.7.7 0 1 0 0-1.408H130.7a.7.7 0 0 0 0 1.408z",
    transform: "translate(732.631 125.092)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 427",
    d: "M56.891 378h-2.069a.7.7 0 1 0 0 1.408h2.069a.7.7 0 1 0 0-1.408z",
    transform: "translate(803.166 125.092)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 428",
    d: "m34.4 20.681-1.026-.688v-1.452a1.408 1.408 0 0 0 .7-1.218v-2.535a1.41 1.41 0 0 0-1.408-1.408H20a1.41 1.41 0 0 0-1.408 1.408v2.535a1.408 1.408 0 0 0 .7 1.218v1.453l-1.026.688a3.716 3.716 0 0 0-1.65 3.092v10.168a2.1 2.1 0 0 0 .121.7H2.113a.7.7 0 0 1-.7-.7V3.521a2.115 2.115 0 0 1 2.108-2.113h22.4a3.5 3.5 0 0 0-.706 2.113v7.224a.7.7 0 1 0 1.408 0V3.521a2.113 2.113 0 1 1 4.225 0v4.788h-2.61a.7.7 0 1 0 0 1.408h3.31a.7.7 0 0 0 .7-.7V3.521A3.525 3.525 0 0 0 28.731 0H3.521A3.525 3.525 0 0 0 0 3.521v30.421a2.115 2.115 0 0 0 2.113 2.113h31.83a2.115 2.115 0 0 0 2.113-2.113V23.774a3.716 3.716 0 0 0-1.656-3.093zM20 14.788h12.675v2.535h-1.252V16.3a.7.7 0 0 0-1.408 0v1.028H28.5V16.3a.7.7 0 0 0-1.408 0v1.028H25.58V16.3a.7.7 0 1 0-1.408 0v1.028h-1.513V16.3a.7.7 0 1 0-1.408 0v1.028H20zm14.646 19.154a.7.7 0 0 1-.7.7H18.732a.7.7 0 0 1-.7-.7V23.774a2.311 2.311 0 0 1 1.026-1.923l1.338-.9a.7.7 0 0 0 .312-.585v-1.634H31.97v1.638a.7.7 0 0 0 .312.585l1.338.9a2.311 2.311 0 0 1 1.026 1.923z",
    style: {
      fill: "#fff"
    },
    transform: "translate(853.473 476.473)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 429",
    d: "M333.774 340.473h-1.831v-1.831a.7.7 0 1 0-1.408 0v1.831H328.7a.7.7 0 1 0 0 1.408h1.831v1.831a.7.7 0 1 0 1.408 0v-1.831h1.831a.7.7 0 1 0 0-1.408z",
    transform: "translate(548.571 162.332)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 430",
    d: "M297.774 301.938a5.774 5.774 0 1 0 5.774 5.774 5.781 5.781 0 0 0-5.774-5.774zm0 10.14a4.366 4.366 0 1 1 4.366-4.366 4.371 4.371 0 0 1-4.366 4.366z",
    transform: "translate(582.035 195.797)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 431",
    d: "M60.338 54h-2.817a.7.7 0 0 0-.7.7v2.113H54.7a.7.7 0 0 0-.7.7v2.817a.7.7 0 0 0 .7.7h2.113v2.113a.7.7 0 0 0 .7.7h2.817a.7.7 0 0 0 .7-.7v-2.101h2.113a.7.7 0 0 0 .7-.7v-2.821a.7.7 0 0 0-.7-.7h-2.101V54.7a.7.7 0 0 0-.704-.7zm2.113 4.225v1.408h-2.113a.7.7 0 0 0-.7.7v2.117h-1.413v-2.112a.7.7 0 0 0-.7-.7h-2.117v-1.413h2.113a.7.7 0 0 0 .7-.7v-2.117h1.408v2.113a.7.7 0 0 0 .7.7z",
    transform: "translate(803.276 426.276)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 432",
    d: "M266.473 114a.7.7 0 1 0 0 1.408h3.381a.7.7 0 0 0 0-1.408z",
    transform: "translate(606.419 370.501)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 433",
    d: "M225.206 114.206a.7.7 0 1 0 .5-.206.71.71 0 0 0-.5.206z",
    transform: "translate(644.317 370.501)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 434",
    d: "M49.618 427.157a.7.7 0 0 0 1 0l.558-.557.865.865a1.4 1.4 0 0 0 1.981 0l1.4-1.4a.7.7 0 1 0-1-1l-1.392 1.392-.865-.865a1.4 1.4 0 0 0-1.981 0l-.563.563a.7.7 0 0 0-.003 1.002z",
    transform: "translate(807.54 81.527)",
    style: {
      fill: "#fff"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderMedicines);
export default __webpack_public_path__ + "static/media/order-medicines.37c42b00450080cca8ba577dce65e690.svg";
export { ForwardRef as ReactComponent };